import { default as formsEN } from "./en/forms.json";
import { default as usersEN } from "./en/user-management.json";

export const sharedEN = {
  forms: formsEN,
  users: usersEN,
};
